/* eslint-env browser, jquery */
/* global WOW, imagesLoaded, Wistia, Auth0Lock */
// const debug = require('debug')('auth0:how-it-works');
import container from 'modules/section-content';
import requireg from 'modules/npm-component/require-global';
import metrics from 'modules/metrics';
import domify from 'domify';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import metadata from './metadata.json';
import splash from './dashboard-page.pug';

let playVideoIntent = setTimeout(() => {}, 1), switchTabIntent = setTimeout(() => {}, 1);

export default function register() {
  page('/jp/how-it-works', render, loadscripts, onPageReady);
}

function render(ctx, next) {
  preventScrolling(true);
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadscripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    requireg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    requireg(
      '//cdnjs.cloudflare.com/ajax/libs/jquery.imagesloaded/4.1.0/imagesloaded.pkgd.min.js',
      'imagesLoaded',
      done
    );
  });

  batch.push(done => {
    requireg(
      '//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js',
      '$.fn.typetype',
      done
    );
  });

  batch.push(done => {
    requireg('//fast.wistia.com/assets/external/E-v1.js', 'Wistia', done);
  });

  batch.end(next);
}

function onPageReady(ctx, next) {
  // global Wistia options
  // for all videos!
  Wistia.options({
    videoQuality: 'hd-only',
    videoFoam: true,
    chromeless: true
  });

  // Tell wistia to initialize videos
  // manually...
  Wistia.embeds.setup();

  imagesLoaded('.jp-dashboard-page .page-hero', () => {
    initCoverPage(0);
  });

  initScrollAnimations();
  attachEvents();
  demoLock();

  next();
}

function demoLock() {
  const auth0IconUrl =
    'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png';

  const AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
  const AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
  const AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

  const demoOptions = {
    auth: { redirectUrl: AUTH0_CALLBACK_URL },
    theme: {
      logo: auth0IconUrl
    },
    rememberLastLogin: false,
    container: 'iphone',
    integratedWindowsLogin: false,
    socialButtonStyle: 'small',
    languageDictionary: {
      // eslint-disable-next-line max-len
      signUpTerms: 'By signing up, you agree to our <a href="/terms" target="_new">terms of service</a> and <a href="/privacy" target="_new">privacy policy</a>'
    }
  };

  const demo = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, demoOptions);
  demo.show();
}

function preventScrolling(activate) {
  const $body = $('body');

  $body.addClass('no-scroll');
  $body.bind('touchmove', e => {
    e.preventDefault();
  });

  if (!activate) {
    $body.removeClass('no-scroll');
    $body.unbind('touchmove');
  }
}

function requestAnimFrame(cb) {
  if (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame
  ) {
    return (
      requestAnimationFrame(cb) || webkitRequestAnimationFrame(cb) || mozRequestAnimationFrame(cb)
    );
  } else {
    return setTimeout(cb, 1000 / 60);
  }
}

function animateEditUsers() {
  const $inputs = $('.js-edit-user-animation input');
  const $modal = $('.js-edit-user-animation .modal-edit-content');
  const $save = $('.js-edit-user-animation .btn');

  const steps = [
    'Ricardo Rauch',
    'ricky@auth0.com',
    'RickyRauch',
    'Auth0',
    'Buenos Aires, Argentina',
    'http://auth0.com/'
  ];

  function resetForm() {
    $save.text($save.data('o_val')).removeClass('focused');

    $modal.prepend('<div class="alert alert-success" style="font-size: 14px;">Changes saved</div>');

    setTimeout(() => {
      $modal.find('.alert').remove();
    }, 2000);
  }

  function modifyText(i, value, total) {
    return function() {
      const toCall = parseInt(i) + 1;

      $inputs.eq(i).data('o_val', $inputs.eq(i).val());
      $inputs.eq(i).addClass('focused').val('').delay(700).typetype(value, {
        e: 0.04,
        t: 85,
        callback() {
          $inputs.eq(i).removeClass('focused');

          if (toCall < total) {
            stack[toCall]();
          } else {
            save();
          }
        }
      });
    };
  }

  function save() {
    setTimeout(() => {
      $save.data('o_val', $save.text());
      $save.text('Saving...').addClass('focused');

      setTimeout(() => {
        resetForm();
      }, 400);
    }, 600);
  }

  let stack = {};

  for (const step in steps) {
    const current = steps[step];

    stack[step] = modifyText(step, current, steps.length);
  }

  stack[0]();
}

function initScrollAnimations() {
  const regularAnimations = new WOW({
    boxClass: 'js-animated',
    animateClass: 'animated',
    offset: 200,
    mobile: false,
    callback(box) {
      const $after = $(box).siblings().filter('.hide.js-animated-after');

      if ($after.length) {
        setTimeout(() => {
          $after.removeClass('hide').addClass('animated');
        }, 400);
      }

      if ($(box).find('.js-edit-user-animation').length) {
        animateEditUsers();
      }
    }
  });

  const screenshotsAnimation = new WOW({
    boxClass: 'js-contains-videos',
    animateClass: 'animated',
    offset: 0,
    mobile: false,
    callback(box) {
      let $playOnScroll = $(box).find('.lock-demo'), $phoneUp = $('.showcase-area .iphone-lock');

      const whenShowLock = 18;
      const whenChangeLogo = 23;
      const whenChangeSocial = 38;

      if ($playOnScroll.hasClass('wistia_embed')) {
        const video = Wistia.api($playOnScroll.data('source'));
        video &&
          video.bind('secondchange', second => {
            if (second === whenShowLock) {
              $phoneUp.removeClass('hide');
            }

            if (second === whenChangeLogo) {
              $phoneUp
                .find('#iphone .auth0-lock-header-logo')
                .attr('src', 'https://cdn.auth0.com/website/assets/pages/dashboard/img/sharelock-icon-19e529d979.svg');
              $phoneUp.find('.a0-avatar').addClass('a0-hide');
              $phoneUp.find('.a0-image').removeClass('a0-hide');
            }

            if (second === whenChangeSocial) {
              $phoneUp.find('#iphone').removeClass('lock-no-googleplus');
            }
          });

        video.play();
      }
    }
  });

  const profileAutoplay = new WOW({
    boxClass: 'js-switch-profile',
    animateClass: 'triggered',
    offset: -600,
    mobile: false,
    callback(box) {
      $('.js-switch-profile .profile.right img').trigger('click');

      // autoPlay commented that causes an error

      // setProfileAutoplay(2000);
    }
  });

  regularAnimations.init();
  screenshotsAnimation.init();
  profileAutoplay.init();
}

function profileSwitch(e) {
  let $clicked = $(this),
    $profiles = $('.js-switch-profile .profile'),
    $dots = $('.js-switch-profile .dot');

  if ($clicked.parent().hasClass('right')) {
    goToDirection('right');
  }

  if ($clicked.parent().hasClass('left')) {
    goToDirection('left');
  }

  if ($clicked.hasClass('dot')) {
    goToIndex();
  }

  if (window.profileAutoplay === false) {
    metrics.lib().track('click:dashboard-profiles');
  }

  function goToIndex() {
    const index = $clicked.index();
    const $target = $profiles.eq(index);

    $clicked = $target.find('img');

    if ($target.hasClass('center')) {
      return;
    }

    if ($target.hasClass('left')) {
      goToDirection('left');
    }

    if ($target.hasClass('right')) {
      goToDirection('right');
    }
  }

  function goToDirection(direction) {
    const inverse = direction === 'left' ? 'right' : 'left';

    $profiles.filter('.back').first().removeClass('back').addClass(direction);
    $profiles.filter(`.${inverse}`).removeClass(inverse).addClass('back');
    $profiles.filter('.center').removeClass('center').addClass(inverse);

    updateClicked();
  }

  function updateClicked() {
    $dots.removeClass('selected');

    $clicked.parent().removeClass('right left').addClass('center');

    $dots.eq($clicked.parent().index()).addClass('selected');
  }
}

function setProfileAutoplay(time) {
  if (!window.profileAutoplay) {
    window.profileAutoplay = setInterval(play, time);
  }

  $('.js-switch-profile').hover(
    () => {
      clearInterval(window.profileAutoplay);

      window.profileAutoplay = false;
    },
    () => {
      if (!window.profileAutoplay) {
        window.profileAutoplay = setInterval(play, time);
      }
    }
  );

  function play() {
    $('.js-switch-profile .profile.right img').trigger('click');
  }
}

function switchVideos(e) {
  e.preventDefault();
  e.stopPropagation();

  const $clicked = $(this);
  const index = $clicked.index();
  const $videos = $clicked.parents('.js-video-switcher').find('.video-wrapper');
  const $siblings = $videos.eq(index).siblings();

  if ($clicked.hasClass('active')) {
    return false;
  }

  metrics.lib().track('click:dashboard-tab-switcher', { tab: $clicked[0].className });

  // Set fadeout animation for current slide w/ custom duration
  $siblings.css({
    '-webkit-animation-duration': 400,
    'animation-duration': 400
  });

  $siblings.addClass('fadeOutDownBig');

  clearTimeout(playVideoIntent);
  clearTimeout(switchTabIntent);

  switchTabIntent = setTimeout(() => {
    // Reset animation duration, hide other tabs, remove fadeOut animation
    $siblings.removeAttr('style').addClass('hide').removeClass('fadeOutDownBig');

    $videos.eq(index).removeClass('hide');

    $clicked.siblings().removeClass('active');
    $clicked.addClass('active');

    $videos.eq(index).find('video').get(0).currentTime = 0;
  }, 300);

  // playVideoIntent = setTimeout(function() {
  //     $videos.eq(index).find('video').get(0).play();
  // }, 800);

  playVideoIntent = setTimeout(() => {
    let $videoMarkup = $('.js-video-switcher').find('.dash-demo'),
      $phoneUp = $('.screenshots .iphone-dash');

    if ($videoMarkup.hasClass('wistia_embed')) {
      const videoSource = Wistia.api($videoMarkup.data('source'));
      videoSource.bind('end', second => {
        $phoneUp.removeClass('hide');
      });
    }
  }, 300);
}

function attachEvents() {
  $('.jp-dashboard-page')
    .on('click', '.js-switch-profile .profile img', profileSwitch)
    .on('click', '.js-switch-profile .dot', profileSwitch)
    .on('click', '.js-video-switcher .tab-list a', switchVideos);

  $('.mark-red .shape').hover(
    function() {
      $(this).parent('.mark-red').next('.tooltip').addClass('animated fadeInUp show');
    },
    function() {
      $(this).parent('.mark-red').next('.tooltip').removeClass('animated fadeInUp show');
    }
  );

  window.wistiaInit = function(W) {
    const $allVideos = $('.wistia_embed');

    $allVideos.each((i, el) => {
      const video = W.api($(el).data('source'));

      video &&
        video.bind('play', function() {
          metrics.lib().track('click:dashboard-video', { video: this.name() });
        });
    });
  };
}

function initCoverPage(time) {
  preventScrolling(false);

  const $stack = $('.jp-dashboard-page .banner').find('.js-animation-stack');

  setTimeout(() => {
    $('.js-intro-text').removeClass('invisible').addClass('scaleIn');
    $('.jp-dashboard-page .spinner-container').fadeOut(300);

    setTimeout(() => {
      $('.jp-dashboard-page .banner .mobile-screen').removeClass('invisible');
      $('.jp-dashboard-page .banner .btn').removeClass('invisible').addClass('animated fadeIn');
      $('.jp-dashboard-page .banner .p-dashboard-1')
        .removeClass('invisible')
        .addClass('animated fadeInUp');
    }, 600);

    setTimeout(() => {
      $('.jp-dashboard-page .banner .p-dashboard-2')
        .removeClass('invisible')
        .addClass('animated fadeInUp');

      if ($stack.length) {
        const wait = 250;

        $stack.find('[data-order]').each(function() {
          const elem = $(this);
          const order = parseInt($(this).attr('data-order'));

          const timeout = setTimeout(() => {
            elem.removeClass('hide').addClass('animated');

            clearTimeout(timeout);
          }, wait * order);
        });
      }
    }, 1200);
  }, time || 600);
}



// WEBPACK FOOTER //
// ./src/pages/jp/how-it-works/dashboard.js